export default (editor, { defaultModel, defaultView, ...config }) => {
  const type = 'accordion'
  const { attrAccordion, classAccordion } = config

  editor.DomComponents.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Accordion',
        'attr-accordion': config.attrAccordion,
        'attr-accordion-header': config.attrAccordionHeader,
        'attr-accordion-content': config.attrAccordionContent,
        'class-accordion-active': config.classAccordionActive,
        ...config.accordionProps
      },
      init() {
        const attrs = this.getAttributes()
        attrs[config.attrAccordion] = 1
        this.setAttributes(attrs)
        classAccordion && this.addClass(classAccordion)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrAccordion)) {
          return { type }
        }
      }
    }),
    view: defaultView.extend({
      init() {
        const comps = this.model.components()
        !comps.length && comps.add(config.template)
      },
      onRender() {
        const accordion = this.model.find(`[${config.attrAccordion}]`)[0]
        accordion && accordion.components().each(item => {
          accordion.onAdd(item)
        })
        editor.Canvas.getWindow().AfrusEditor.loadAccordion(this.el)
      }
    })
  })
}
